const MUSIC_MUTED_KEY = 'vizipedia-city-builder:musicMuted';
const SFX_MUTED_KEY = 'vizipedia-city-builder:sfxMuted';

type MuteListener = (muted: boolean) => void;

const musicListeners = new Set<MuteListener>();
const sfxListeners = new Set<MuteListener>();

function notifyMusic(muted: boolean): void {
    musicListeners.forEach((listener) => listener(muted));
}

function notifySfx(muted: boolean): void {
    sfxListeners.forEach((listener) => listener(muted));
}

function readStored(key: string): boolean {
    try {
        return localStorage.getItem(key) === 'true';
    } catch {
        return false;
    }
}

function writeStored(key: string, muted: boolean): void {
    try {
        localStorage.setItem(key, String(muted));
    } catch {
        // Storage is optional.
    }
}

/**
 * Persisted mute state only — applying it to audio is the AudioManager's job,
 * because muting one channel must not silence the other.
 */

export function isMusicMuted(): boolean {
    return readStored(MUSIC_MUTED_KEY);
}

export function setMusicMuted(muted: boolean): void {
    writeStored(MUSIC_MUTED_KEY, muted);
    notifyMusic(muted);
}

export function subscribeMusicMuted(listener: MuteListener): () => void {
    musicListeners.add(listener);
    return () => musicListeners.delete(listener);
}

export function isSfxMuted(): boolean {
    return readStored(SFX_MUTED_KEY);
}

export function setSfxMuted(muted: boolean): void {
    writeStored(SFX_MUTED_KEY, muted);
    notifySfx(muted);
}

export function subscribeSfxMuted(listener: MuteListener): () => void {
    sfxListeners.add(listener);
    return () => sfxListeners.delete(listener);
}
